/**
 * @file
 * Embed video functionality.
 */

(($, { behaviors }) => {
  /**
   * Embed a video.
   *
   * @param {jQuery} $video
   *   A video DOM element.
   */
  function embedVideo($video) {
    const $videoContainer = $video.find(".js-video__container");
    const $videoEmbed = $videoContainer.find(".js-video__embed-code");

    // Construct a new div with the embed code inside.
    const div = document.createElement("div");
    div.className = "video__player";
    div.innerHTML = $videoEmbed.html();
    // Append the div to our video container.
    $videoContainer.append(div);
  }

  /**
   * Expand the video player and hide overlay content.
   *
   * @param {jQuery} $video
   *   A video DOM element.
   */
  function expandVideoPlayer($video) {
    const $closeVideoButton = $video.find(".js-video__close-button");
    const $videoOverlay = $video.find(".js-video__overlay");
    const $videoInner = $video.find(".js-video__inner");
    const $videoImage = $video.find(".js-video__image");

    $closeVideoButton.addClass("video__close-button--visible");
    $videoOverlay.addClass("video__overlay--hidden");
    $videoInner.addClass("video__inner--hidden");
    $videoImage.addClass("video__image--hidden");
    $video.addClass("video--expanded");
  }

  /**
   * Shrink the video player and show overlay content.
   *
   * @param {jQuery} $video
   *   A video DOM element.
   */
  function shrinkVideoPlayer($video) {
    const $closeVideoButton = $video.find(".js-video__close-button");
    const $videoOverlay = $video.find(".js-video__overlay");
    const $videoInner = $video.find(".js-video__inner");
    const $videoImage = $video.find(".js-video__image");

    $closeVideoButton.removeClass("video__close-button--visible");
    $video.removeClass("video--expanded");
    $videoImage.removeClass("video__image--hidden");
    $videoOverlay.removeClass("video__overlay--hidden");
    $videoInner.removeClass("video__inner--hidden");
  }

  /**
   * Close video player and remove video.
   *
   * @param {jQuery} $video
   *   A video DOM element.
   */
  function closeVideoPlayer($video) {
    const $videoPlayer = $video.find(".video__player");
    $videoPlayer.remove();
  }

  /**
   * Attaches behaviors for embedding a video.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *  Attaches embed video functionality.
   */
  behaviors.embedVideo = {
    attach(context) {
      const $playVideoButton = $(".js-video__play-button", context);

      once(
        "video-play-button-pressed",
        ".js-video__play-button",
        context
      ).forEach((element) => {
        element.addEventListener("click", (event) => {
          const $this = $(event.currentTarget);
          const $video = $this.closest(".js-video", context);

          if (
            $this
              .parent()
              .find(".video__link")
              .attr("href")
              .indexOf("play.gu") > 0 ||
            Drupal.eu_cookie_compliance
              .getAcceptedCategories()
              .indexOf("marketing") > 0
          ) {
            $this.prop("disabled", true);
            expandVideoPlayer($video);
            embedVideo($video);
          } else {
            $("body").prepend(
              `<div class="cookie-overlay"><div class="popup"><h2><a href="#" class="accept-cookies">${Drupal.t(
                "You need to accept cookies"
              )}</a></h2><p>${Drupal.t(
                "In order to play this clip you need to allow all cookies."
              )}</p><button class="show-cookie-banner">OK</button></div></div>`
            );
            $(".cookie-overlay").fadeIn();
            $(".accept-cookies").focus();
            /* eslint-disable-next-line max-nested-callbacks */
            $(".show-cookie-banner").click(() => {
              $(".cookie-overlay").remove();
              if (!$("body").hasClass("eu-cookie-compliance-popup-open")) {
                $(".eu-cookie-withdraw-tab").click();
              }
            });
          }
        });
      });

      once(
        "video-close-button-pressed",
        ".js-video__close-button",
        context
      ).forEach((element) => {
        element.addEventListener("click", (event) => {
          const $this = $(event.currentTarget);
          const $video = $this.closest(".js-video", context);

          shrinkVideoPlayer($video);
          closeVideoPlayer($video);

          $playVideoButton.prop("disabled", false);
        });
      });
    },
  };
})(jQuery, Drupal);
